import styled from 'styled-components';

import {
  mediaQueryMobileMin,
  fontFamilyPrimary,
  colorBlack900,
  colorWhite,
  colorPrimaryDarken10,
  colorPrimaryLighten95,
  colorGrey200,
} from 'styles';

export const Wrapper = styled.div`
  margin: 0;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    background: linear-gradient(
      270deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  @media all and ${mediaQueryMobileMin} {
    width: auto;

    &:after {
      display: none;
    }
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  font-family: ${fontFamilyPrimary};
  line-height: 31px;
  height: 32px;
  font-size: 14px;
  color: ${colorBlack900};
  background: ${colorWhite};
  border: 1px solid ${colorGrey200};
  border-radius: 4px;
  padding: 0 8px;
  text-align: center;
  margin-right: 4px;

  &:hover {
    color: ${colorPrimaryDarken10};
    background: ${colorPrimaryLighten95};
  }
`;

export const Group = styled.div`
  display: flex;
`;
